angular.module("vgresiduos").component("disposalCostsPreference", {
	controller: "DisposalCostsPreferenceCtrl",
	templateUrl: "views/components/disposalCostsPreference/disposalCostsPreference_template.html",
	bindings: {
		model: "=",
		closeRadio: "<"
	}
});
